import { createSvgIcon } from "@mui/material";

const MemberEducationIcon = createSvgIcon(
    <svg id="Ebene_2" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 42.89 41.27"
        fill="currentColor"
        stroke="currentColor"
    >
        <g id="Ebene_1-2">
            <path d="M19.43 31.19c-.66-.22-1.15-.82-1.27-1.58-.15-.88.19-1.73.86-2.18l.13-.09.15-.06 11.12-4.42.05-.02c-1.58-2.52-5.23-3.33-7.04-3.33-1.68 0-3.9-1.75-3.9-3.9v-.25c1.77-2.09 2.93-5.24 2.93-7.56 0-3.77-.98-7.81-6.83-7.81S8.8 4.02 8.8 7.8c0 2.32 1.16 5.47 2.93 7.56v.25c0 2.16-1.71 3.9-3.9 3.9-3.03 0-7.72 1.99-7.82 5.86-.03 1.13 0 3.9 0 3.9 0 1.08.87 1.95 1.95 1.95h17.55l-.08-.03Z" />
            <path d="M40.09 41.27h2.15s.4-.37.4-.4v-3.22c0-.42-.64-.68-.85-.88l-.06-6.66c.04-.2 1.48-.27 1.11-1.19-.34-.31-.73-.43-1.1-.6-3.52-1.55-7.2-2.85-10.75-4.07l-11.12 4.42c-.33.22-.29 1 .08 1.1l11.35 4.42 9.43-3.7v6.19c0 .2-.9.33-.9 1.13v3.3h.04c.1 0 .21.17.25.17Z" />
            <path d="M38.9 37.15v-4.34l-7.07 2.78-.55.21-.55-.21-7.3-2.84v4.32s1.21 1.37 2.15 1.84c1.82.92 3.76 1.39 5.69 1.39 1.24 0 2.47-.19 3.68-.58.63-.2 3.95-1.64 3.95-2.58Z" />
        </g>
    </svg>

    , 'MemberEducationIcon')

export default MemberEducationIcon
